export default __webpack_public_path__ + "media/images/preview-3bb6b9c7f0ea2da87f10cde182f089a9.png";